<template>
  <CardGraphicWithBorder
    class="card"
    img-alt="Agenda"
    img-src="/images/assessment/coaching.svg"
    :show-controls="true"
    :close-click-outside="true"
  >
    <template #title> Planifie tes évals en illimité </template>
    <template #description>
      <p>
        <strong>Profite</strong> d'un <strong>coaching</strong> de
        <strong>révision</strong> personnalisé
        <strong>selon tes besoins</strong> ❤️‍🔥
      </p>
    </template>
    <template #footer>
      <ButtonBase
        :to="`${runtimeConfig.public.eva1Url}/premium`"
        :rounded="true"
        theme="secondary"
        stroke="n"
        class="button"
        size="small"
        @click="() => dialog.close()"
      >
        Débloquer
      </ButtonBase>
    </template>
  </CardGraphicWithBorder>
</template>

<script setup lang="ts">
const dialog = useDialogStore();
const runtimeConfig = useRuntimeConfig();
</script>
<style lang="scss" scoped>
.card {
  justify-self: center;
  width: 32rem;
  box-shadow: rgb(0 0 0 / 16%) 0 10px 36px 0, rgb(0 0 0 / 6%) 0 0 0 1px;

  @include above('l') {
    width: 50rem;
  }
}
</style>
